@if(pageInfo.urls) {
<div
  class="bg-white rounded p-y-30 p-x-24 m-b-30 overflow-hidden d-flex align-items-center justify-content-between"
>
  <h4 class="page-title m-0 f-s-20 f-w-600">
    {{ pageInfo?.['title'] }}
  </h4>
  <div class="d-flex align-items-center overflow-hidden">
    <ul class="breadcrumb">
      @for (url of pageInfo?.['urls']; track url.url;let index = $index,last =
      $last ) { @if(!last){
      <li class="breadcrumb-item" [routerLink]="url.url">
        <a [routerLink]="url.url">{{ url.title }}</a>
      </li>
      }@else {
      <li class="breadcrumb-item m-l-20">
        <i-tabler name="circle-filled" class="icon-8"></i-tabler>
      </li>
      <li class="breadcrumb-item active f-s-14">{{ url.title }}</li>
      } }
    </ul>
  </div>
</div>
}
